import React from 'react';
import PropTypes from 'prop-types';
import ModalManager from '../../elements-modal/modal-manager-v2';
import { SyncSelectCal } from './modal-sync-cal-select';
import { SuccessSyncModal } from './modal-sync-cal-success';
import { DisconnectSyncModal } from './modal-sync-disconnect';
import { ExternalCalendarSyncModal } from './modal-external-cal-connect';
import { ImportCalendarModal } from './modal-import-calendar';
import WhyCantSyncModal from './modal-survey-why-cant-sync';
import { ReminderModal } from 'shared-components/survey-modals/modal-survey-want-a-reminder';
import { NotificationChoiceModal } from './modal-survey-notification-choice';
import { SurveyCompleteModal } from 'shared-components/survey-modals/modal-survey-complete';
import { ModalSyncSteps } from './modal-sync-steps';
import { SuccessIcalModal } from './modal-ical-success';
import { ModalIcalShare } from './modal-ical-share';
import { BlockDayModal } from './modal-block-day';
import BufferTimeModal from './buffer-time';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import Calendar from '../../../../api/api-calendar';
import { formValueSelector } from 'redux-form';

import { get } from 'lodash';

class SyncFlowComponent extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      calendarSurvey: {
        cannot_sync_reasons: [],
        external_calendars: [],
        reminder_preference: [],
        other_reason: ''
      },
      surveyError: false
    };
    this.updateSyncReasons = this.updateSyncReasons.bind(this);
    this.updateCalendarSyncReminder = this.updateCalendarSyncReminder.bind(this);
    this.isCalendarSurveyComplete = this.isCalendarSurveyComplete.bind(this);
  }

  updateSyncReasons (payload, callback) {
    const accessToken = get(this.props, 'accessToken');
    const spaceId = get(this.props, 'spaceId', '');
    Calendar.updateCalendarSyncReasons(spaceId, accessToken, payload, (response) => {
      const { statusCode } = response;
      if (200 !== statusCode) {
        this.setState({ surveyError: true });
      } else {
        this.setState({ calendarSurvey: response });
      }
    });
  }

  updateCalendarSyncReminder (payload, callback) {
    const accessToken = get(this.props, 'accessToken');
    const spaceId = get(this.props, 'spaceId', '');
    Calendar.updateCalendarSyncReminder(spaceId, accessToken, payload, (response) => {
      const { statusCode } = response;
      if (200 !== statusCode) {
        this.setState({ surveyError: true });
      } else {
        if (callback) callback();
      }
    });
  }

  isCalendarSurveyComplete () {
    const { calendarSurvey } = this.state;
    const hasCurrentSync = calendarSurvey.sync_state && (calendarSurvey.sync_state === 'SYNCING' || calendarSurvey.sync_state === 'CONNECTED');
    if (calendarSurvey.hasOwnProperty('has_external_calendar') && !calendarSurvey.has_external_calendar) return true;
    return (hasCurrentSync || (calendarSurvey.hasOwnProperty('reminder_frequency')));
  }

  render () {
    const { intl, whichModal } = this.props;
    const translationMessages = defineMessages({
      syncFlowOneHeading: {
        id: 'hosting.sync_flow_main.sync_calendar_heading',
        defaultMessage: 'Sync your calendar with Peerspace'
      },
      syncFlowOneText: {
        id: 'hosting.sync_flow_main.sync_calendar_info_text',
        defaultMessage: 'Connect an external calendar to show your availability in real time and increase your bookings.'
      },
      syncFlowTwoHeading: {
        id: 'hosting.sync_flow_main.sync_check_mark_heading',
        defaultMessage: 'Syncing is easy'
      },
      syncFlowTwoText: {
        id: 'hosting.sync_flow_main.sync_check_mark_info_text',
        defaultMessage: 'Connect your Google Calendar, iCal, Outlook, or Exchange account in a few easy steps.'
      },
      syncFlowThreeHeading: {
        id: 'hosting.sync_flow_main.sync_lock_heading',
        defaultMessage: 'You’re in control'
      },
      syncFlowThreeText: {
        id: 'hosting.sync_flow_main.sync_lock_info_text',
        defaultMessage: 'Adjust your availability on the fly. We will never share your personal information or event details.'
      },
      syncFlowFourHeading: {
        id: 'hosting.sync_flow_main.sync_space_heading',
        defaultMessage: 'Let’s start by picking a space'
      },
      syncFlowFourText: {
        id: 'hosting.sync_flow_main.sync_space_info_text',
        defaultMessage: 'Select the space you want to sync your calendar with. If you have multiple spaces, you can repeat this process for each.'
      }
    });
    const syncFlow = [
      {
        id: 'SyncFlow1',
        body: {
          image: 'sync-calendar',
          heading: intl.formatMessage(translationMessages.syncFlowOneHeading),
          infoText: intl.formatMessage(translationMessages.syncFlowOneText)
        },
        nextModal: 'SyncFlow2'
      },
      {
        id: 'SyncFlow2',
        body: {
          image: 'sync-checkmark',
          heading: intl.formatMessage(translationMessages.syncFlowTwoHeading),
          infoText: intl.formatMessage(translationMessages.syncFlowTwoText)
        },
        nextModal: 'SyncFlow3',
        previousModal: 'SyncFlow1'
      },
      {
        id: 'SyncFlow3',
        body: {
          image: 'sync-lock',
          heading: intl.formatMessage(translationMessages.syncFlowThreeHeading),
          infoText: intl.formatMessage(translationMessages.syncFlowThreeText)
        },
        nextModal: 'SyncFlow4',
        previousModal: 'SyncFlow2'
      },
      {
        id: 'SyncFlow4',
        body: {
          componentName: 'SyncSpaceModalBody',
          heading: intl.formatMessage(translationMessages.syncFlowFourHeading),
          infoText: intl.formatMessage(translationMessages.syncFlowFourText)
        },
        previousModal: 'SyncFlow3'
      }
    ];
    return (
      <ModalManager whichModal={whichModal}>
        <SyncSelectCal id="SyncSelectCal" {...this.props} />
        <ExternalCalendarSyncModal id="ConnectExternalCalendar" {...this.props} />
        <ImportCalendarModal id="ImportCalendarModal" surveyComplete={this.state.surveyError || this.isCalendarSurveyComplete()} {...this.props} />
        <DisconnectSyncModal id="DisconnectSyncModal" {...this.props} />
        <SuccessIcalModal id="SuccessIcalModal" {...this.props} />
        <ModalIcalShare id="ShareCalendar" {...this.props} />
        <SuccessSyncModal id="SuccessSyncModal" {...this.props} />
        <BlockDayModal id="BlockDayModal" {...this.props} />
        <BufferTimeModal id="BufferTimeModal" {...this.props} />
        <WhyCantSyncModal
          id="WhyCantSyncModal"
          {...this.props}
          updateSyncReasons={this.updateSyncReasons}
          returnModal="ImportCalendarModal"
          initialValues={{
            cannot_sync_reasons: [],
            other_selected: false,
            other_reason: ''
          }}
        />
        <ReminderModal
          id="ReminderModal"
          {...this.props}
          updateCalendarSyncReminder={this.updateCalendarSyncReminder}
        />
        <NotificationChoiceModal
          id="NotificationChoiceModal"
          {...this.props}
          updateCalendarSyncReminder={this.updateCalendarSyncReminder}
          initialValues={{
            reminder_preference: []
          }}
        />
        <SurveyCompleteModal
          id="SurveyCompleteModal"
          {...this.props}
        />
        {
          syncFlow.map((flow, i) => {
            return (
              <ModalSyncSteps
                key={flow.id}
                id={flow.id}
                length={syncFlow.length}
                index={i}
                {...flow}
                {...this.props}
              />
            );
          })
        }
      </ModalManager>
    );
  }
}

const selector = formValueSelector('CALENDAR_CHOICES_FORM');
export function mapStateToProps (state) {
  const other_reason = selector(state, 'other_reason');
  const other_selected = selector(state, 'other_selected');
  const cannot_sync_reasons = selector(state, 'cannot_sync_reasons');
  const reminder_preference = selector(state, 'reminder_preference');
  return {
    host_survey_form: {
      cannot_sync_reasons,
      other_selected,
      other_reason,
      reminder_preference
    }
  };
}

SyncFlowComponent.propTypes = {
  SSOid: PropTypes.string,
  spaceId: PropTypes.string,
  selectedSpace: PropTypes.string,
  spaces: PropTypes.array,
  changeModal: PropTypes.func,
  whichModal: PropTypes.oneOf([
    'DisconnectSyncModal',
    'ImportCalendarModal',
    'WhyCantSyncModal',
    'ReminderModal',
    'NotificationChoiceModal',
    'SurveyCompleteModal',
    'BlockDayModal',
    'ConnectExternalCalendar',
    'SuccessSyncModal',
    'SyncSelectCal',
    'SuccessIcalModal',
    'ShareCalendar',
    'SyncFlow1',
    'SyncFlow2',
    'SyncFlow3',
    'SyncFlow4',
    ''
  ]),
  intl: intlShape
};

const SyncFlowWithIntl = injectIntl(connect(mapStateToProps)(SyncFlowComponent));

const SyncFlow = (props) => {
  return <SyncFlowWithIntl {...props} />;
};

export { SyncFlow };
